import React from 'react';
import './QuestionBubble.css';
import TitleText from './TitleText';

const QuestionBubble = ({ text }) => {
    return (
        <div className="question-bubble-container">
            <TitleText
                text={"Message to Assistant"}
            />
            <div className="question-bubble">
                {text}
            </div>
        </div>
    );
};

export default QuestionBubble;


